exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-button[data-v-66746c00]{background-color:white;color:#1b4e73;border-color:#9b9b9b\n}\n.selected-button[data-v-66746c00]{color:white;background-color:#428bca;border-color:#428bca\n}\n.system-font[data-v-66746c00]{font-family:Arial, Helvetica, sans-serif;font-size:11px\n}\n", ""]);

// exports
